import {
  NotFoundContentMui as NotFoundContent,
  PageLayoutMui as PageLayout,
} from '@spotify/confidence-core-react';

import { useResourcePageLayoutProps } from './useResourcePageLayoutProps';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- rendered inside already-tracked pages via ResourceGuard; tracking happens at the parent
export const ResourceNotFoundErrorPage = () => {
  const pageLayoutProps = useResourcePageLayoutProps();

  return (
    <PageLayout {...pageLayoutProps}>
      <NotFoundContent />
    </PageLayout>
  );
};
